export const defaultAppConfig = {
  app_name: "Rankable",
  app_description: "Rankable empowers founders, marketers, and agencies with AI-driven website audits that transform complex SEO and AEO analyses into clear, prioritized task lists. Our vision is to simplify site optimization by delivering actionable insights anyone on your team can execute. We value clarity, efficiency, and measurable progress to help you grow your organic presence.",
  app_tagline: "From Audit to Action",
  production: process.env.NODE_ENV === "production",
  app_url: process.env.APP_URL || "",
  app_id: process.env.APP_ID || "",
  
  app_logo_url_light:
    "https://app-assets.constructr.ai/0390cd1c-bcdf-4e6c-8e5f-cefb7858f524/branding/logo-light.png",
  app_logo_url_dark:
    "https://app-assets.constructr.ai/0390cd1c-bcdf-4e6c-8e5f-cefb7858f524/branding/logo-dark.png",

  app_full_logo_url_light:
    "https://app-assets.constructr.ai/0390cd1c-bcdf-4e6c-8e5f-cefb7858f524/branding/logo-full-light.png",
  app_full_logo_url_dark:
    "https://app-assets.constructr.ai/0390cd1c-bcdf-4e6c-8e5f-cefb7858f524/branding/logo-full-dark.png",

  app_badge_show: true,
  app_badge_href: "https://constructr.ai?utm_source=badge&utm_campaign=badge",
  app_badge_src: "https://assets.constructr.ai/images/made-with-badge.png",
  app_badge_alt: "Made with Constructr",
  allow_remix: false
};



